function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddRow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.276,12.893C25.276,12.009 24.56,11.293 23.676,11.293L2.324,11.293C1.44,11.293 0.724,12.009 0.724,12.893L0.724,13.307C0.724,14.191 1.44,14.907 2.324,14.907C6.769,14.907 19.231,14.907 23.676,14.907C24.56,14.907 25.276,14.191 25.276,13.307L25.276,12.893Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.207,25.376C14.091,25.376 14.807,24.66 14.807,23.776C14.807,19.331 14.807,6.869 14.807,2.424C14.807,1.54 14.091,0.824 13.207,0.824L12.793,0.824C11.909,0.824 11.193,1.54 11.193,2.424C11.193,6.869 11.193,19.331 11.193,23.776C11.193,24.66 11.909,25.376 12.793,25.376L13.207,25.376Z",
    style: {
      fill: "#fff"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddRow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-row.b7ed2c67735c21ead636d6e7fe07b458.svg";